module.exports = __webpack_public_path__ + "img/6_6.cf298bbc.png";